var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lidaCard ledger-block"},[(_vm.$route.name != 'assortLedgerSearch')?_c('ButtonTool'):_vm._e(),_c('router-view',{key:_vm.$route.fullPath}),_c('BackBottom'),_c('BackTop',{attrs:{"height":100,"right":85}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }